<template>
  <div
    class="feature-product-wrap section-gap title-gap"
    v-if="data && cat && data.length && cat.length"
  >
    <div class="container">
      <div class="sec-title">
        <h2>{{ secTitle }}</h2>
      </div>
      <div class="tab-bar-wrap text-center">
        <div
          v-for="(tab, key) in cat"
          :key="key"
          class="tab-bar d-inline-block"
        >
          <v-btn
            class="d-inline-block"
            :class="{ 'v-btn--flat ': selectedTab === tab.Category_ID }"
            @click="onTabChange(tab.Category_ID)"
            >{{ tab.Category_Title }}</v-btn
          >
        </div>
      </div>
      <div class="tab-content">
        <template v-for="(tab, index) in cat">
          <div v-if="tab.Category_ID === selectedTab" :key="index">
            <slick ref="carousel" :options="slickOptions">
              <template v-for="(cateogary, subindex) in featureValue">
                <div
                  class="tab-item"
                  v-if="cateogary.Category_ID === tab.Category_ID"
                  :key="subindex"
                >
                  <div class="emb-card">
                    <div class="thumb-wrap">
                      <router-link
                        :to="detailPage(cateogary.More_details_page_link)"
                      >
                        <img
                          alt="feature product image"
                          :src="cateogary.Product_Image_626_x_800px"
                          width="626"
                          height="800"
                        />
                      </router-link>
                      <div class="wishlist-icon">
                        <v-btn @click="addItemToWishlist(cateogary)" icon>
                          <v-icon class="grey--text">favorite</v-icon>
                        </v-btn>
                      </div>
                      <div class="add-to-cart">
                        <v-btn
                          v-if="ifItemExistInCart(cateogary, cart)"
                          to="/cart"
                          class="accent"
                          icon
                          absolute
                          bottom
                        >
                        </v-btn>
                        <v-btn
                          @click="addProductToCart(cateogary)"
                          class="accent"
                          icon
                        >
                          <v-icon>shopping_cart</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div class="emb-card-content pa-4">
                      <h5
                        class="font-weight-medium"
                        v-text="cateogary.Name"
                      ></h5>
                      <div class="emb-meta-info layout align-center my-1">
                        <div class="inline-block">
                          <h6 class="accent--text font-weight-medium">
                            {{
                              $n(
                                cateogary.Price /
                                  selectCurrency.CurrencyMultiplier,
                                "currency",
                                selectCurrency.selectedCurrency
                              )
                            }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </slick>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Slick from "vue-slick";
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../../services/utils/cms-helper";

export default {
  props: ["secTitle", "data", "cat"],
  computed: {
    featureValue() {
      return this.data;
    },
    ...mapGetters([
      "rtlLayout",
      "cart",
      "wishlist",
      "products",
      "selectedLocale",
      "selectCurrency",
    ]),
  },

  components: {
    Slick,
  },
  data() {
    return {
      dataRendering: {},
      selectedTab: "",
      activeTab: null,
      slickOptions: {
        autoplay: true,
        slidesToShow: 4,
        infinite: true,
        arrows: false,
        dots: true,
        rtl: this.rtlLayout,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              arrows: false,
              dots: false,
            },
          },
        ],
      },
      selectedCurrency: localStorage.selectedCurrency
        ? localStorage.selectedCurrency
        : "AED",
      CurrencyMultiplier: localStorage.CurrencyMultiplier
        ? parseFloat(localStorage.CurrencyMultiplier)
        : parseFloat(1),
    };
  },
  mounted() {
    this.slickOptions = {
      lazyLoad: "ondemand",
      autoplay: true,
      slidesToShow: 4,
      infinite: true,
      arrows: false,
      dots: true,
      rtl: this.rtlLayout,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            arrows: false,
            dots: false,
          },
        },
      ],
    };
    this.cmsRequestFunctions = gettingRestClientObject();
  },
  watch: {
    cat() {
      if (this.selectedTab == null || this.selectedTab == "") {
        this.tabSelection();
      }
    },

    selectedLocale() {
      this.tabSelection();
    },
  },
  methods: {
    tabSelection: function () {
      this.selectedTab = this.cat[0].Category_ID;
    },
    dataRender() {
      var self = this;
      self.dataRendering = self.data.filter(function (x) {
        return x.Category_ID == self.selectedTab;
      });
    },

    /**
     * method for adding item to cart
     */
    addProductToCart(item) {
      if (this.checkSignInOrNot()) {
        this.$snotify.success(
          this.cmsRequestFunctions.getValidationMsgByCode("M034"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        setTimeout(() => {
          this.$store.dispatch("addProductToCart", item);
        }, 500);
      } else {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M033"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
      }
    },
    /**
     * method for to change item
     */
    onTabChange(key) {
      this.selectedTab = key;
      this.dataRender();
    },
    /**
     * method for checking if item exists in cart
     */
    ifItemExistInCart(result) {
      let exists = false;
      for (let item of this.cart) {
        if (item.id == result.objectID) {
          exists = true;
        }
      }
      return exists;
    },
    // this method is use to add a product in wishlist
    addItemToWishlist(product) {
      if (this.checkSignInOrNot()) {
        this.$snotify.success(
          this.cmsRequestFunctions.getValidationMsgByCode("M035"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        setTimeout(() => {
          this.$store.dispatch("addItemToWishlist", product);
        }, 500);
      } else {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M033"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
      }
    },
    checkSignInOrNot() {
      var user = localStorage.getItem("embryo");
      if (user != null && user != undefined) {
        return true;
      } else {
        return false;
      }
    },
    detailPage(url) {
      if (url != "") {
        url = url.split("/Template/")[1];
        // url = url.split(" ").join("-");
        url = url.split(".").slice(0, -1).join(".");
        url = "/product-details?page=" + url;
      } else {
        url = "#";
      }
      return url;
    },
  },
};
</script>

